import { WhmBox, WhmButton, WhmContainer } from "@securitize/reactjs-whm";
import { useState } from "react";
import BdTermsModal from "../../components/BdTermsModal";
import { MOCK_USER_INFO } from "../mockUserInfo";

export default function BdTermsModalView() {
  const [openCount, setOpenCount] = useState(0);
  const [mounted, setMounted] = useState(false);

  const handleOpen = () => {
    setOpenCount((count) => count + 1);
    setMounted(true);
  };

  const onAccept = () => {
    console.log("BD Terms accepted");
    setMounted(false);
  };

  const onDismiss = () => {
    console.log("BD Terms dismissed");
    setMounted(false);
  };

  return (
    <WhmContainer>
      <WhmBox sx={{ display: "flex", justifyContent: "center", padding: 4 }}>
        <WhmButton onClick={handleOpen} variant="contained">
          Open BD Terms modal
        </WhmButton>
      </WhmBox>
      {mounted && (
        <BdTermsModal
          key={openCount}
          investorId={MOCK_USER_INFO.investorId}
          onAccept={onAccept}
          onDismiss={onDismiss}
        />
      )}
    </WhmContainer>
  );
}
